import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionHeaderAction, SectionHeaderActionsType } from './section-header-action.model';
import { SectionHeaderEvent } from './section-header-event.model';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'iot-platform-ui-section-header',
  imports: [MatIcon, TranslatePipe, MatTooltip, MatButtonModule, NgTemplateOutlet, MatMenuModule],
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './section-header.component.scss'
})
export class SectionHeaderComponent {
  styles = input<any>();
  title = input<string>();
  titleActions = input<SectionHeaderAction[]>([]);
  icon = input<string>();
  svgIcon = input<string>();
  cssClassName = input<string>();
  actions = input<SectionHeaderAction[]>([]);
  actionsType = input<SectionHeaderActionsType>(SectionHeaderActionsType.ICONS);
  showLine = input<boolean>(true);

  dispatchEvent = output<SectionHeaderEvent>();

  SectionHeaderActionsType = SectionHeaderActionsType;

  onDispatchEvent(button: SectionHeaderAction): void {
    this.dispatchEvent.emit({
      type: button.action
    });
  }
}
